export default __webpack_public_path__ + "static/media/video.d48e2181.mp4";